/* eslint-disable max-len */
import React, { useContext, useState } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { WMICCheckbox, WMICButton } from 'wmic-components-platform-react';
import { IntlContext, useTranslator } from '@jutro/locale';
import _ from 'lodash';

import styles from './WMICPremiumBoxFooter.module.scss';
import messages from './WMICPremiumBox.messages';

const WMICPremiumBoxFooter = ({
    isStale,
    showLoading,
    recalculate,
    displayed,
    monthlyAmount,
    fullAmount,
    onBuy
}) => {
    const translator = useTranslator();
    const intl = useContext(IntlContext);

    const [consentedToClue, setConsentedToClue] = useState(false);

    const onRecalculate = () => {
        recalculate();
    }

    if (isStale) {
        return (
            <div className={styles.WMICPremiumBox}>
                <div className={styles.wmicRecalculate}>
                    <div className={styles.wmicRecalculateText}>
                        {translator(messages.yourQuoteChanged)}
                        <br />
                        {translator(messages.clickRecalculate)}
                    </div>
                    <div className={styles.wmicRecalculateButton}>
                        <WMICButton
                            className={cx(styles.recalculateButton, 'ww-btn-secondary')}
                            type="secondary"
                            onClick={onRecalculate}
                            icon="cust-calculator-solid"
                            iconClassName={styles.buttonIcon}
                        >
                            {translator(messages.recalculate)}
                        </WMICButton>
                    </div>
                </div>
            </div>
        );
    }

    if (showLoading) {
        return (
            <div className={styles.WMICPremiumBox}>
                {translator(messages.recalculating)}
            </div>
        );
    }

    const formattedAmount = (currAmount) => intl.formatNumber(
        currAmount.amount,
        {
            style: 'currency',
            currency: currAmount.currency,
            currencyDisplay: 'symbol'
        }
    );

    if (displayed) {
        return (
            <div className={cx(styles.WMICPremiumBox, styles.calculated)}>
                <div className={styles.wmicDisplayedHead}>
                    <div className={styles.wmicPrice}>
                        <h1>{formattedAmount(monthlyAmount)}</h1>
                    </div>
                    <div className={styles.wmicPriceText}>
                        <h3>{translator(messages.monthlyPayment)}</h3>
                        <h4>{translator(messages.fullPayment, { amount: formattedAmount(fullAmount) })}</h4>
                    </div>
                </div>
                <hr />

                <div className={styles.disclaimer}>
                    {translator(messages.acceptMessage)}
                </div>
                <div className={styles.aggreeInput}>
                    <WMICCheckbox
                        name="consentedToClue"
                        id="consentedToClue"
                        value={consentedToClue}
                        onValueChange={() => setConsentedToClue(!consentedToClue)}
                        showInlineLabel
                        label={translator(messages.agree)}
                        labelClassName={styles.wmicAgreeInputLabel}
                    />
                </div>
                <WMICButton
                    className={cx('btn btn-primary', styles.wmicPremiumBoxFooterButton)}
                    type="primary"
                    onClick={onBuy}
                    disabled={!consentedToClue || isStale}
                >
                    {translator(messages.buyPolicy)}
                </WMICButton>
            </div>
        );
    }

    return (
        <span />
    );
};

WMICPremiumBoxFooter.propTypes = {
    isStale: PropTypes.bool,
    showLoading: PropTypes.bool,
    recalculate: PropTypes.func.isRequired,
    onBuy: PropTypes.func.isRequired,
    displayed: PropTypes.bool,
    monthlyAmount: PropTypes.string,
    fullAmount: PropTypes.string
};

WMICPremiumBoxFooter.defaultProps = {
    isStale: false,
    showLoading: false,
    displayed: false,
    monthlyAmount: undefined,
    fullAmount: undefined
};

export default WMICPremiumBoxFooter;